var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskRequests({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wivl7i7uxa",
    d: "M19.469 10.705l.124.115.113.124c.651.784.61 1.957-.11 2.71l-.007.006-5.82 5.817-.205.11-2.86.572c-.28.056-.528-.191-.472-.471l.572-2.859.11-.204 5.82-5.817c.745-.745 1.93-.784 2.735-.103zm-6.332-8.872c.308 0 .603.123.822.34L16.787 5c.219.218.341.513.341.822v2.51c0 .22-.18.4-.4.4-.222 0-.4-.18-.4-.4v-2.51c0-.096-.039-.188-.107-.256L13.394 2.74c-.07-.07-.161-.107-.257-.107H2.997c-.2 0-.363.162-.363.362v16.008c0 .2.162.362.363.362h5.34c.22 0 .4.18.4.4 0 .221-.18.4-.4.4h-5.34c-.643 0-1.164-.52-1.164-1.162V2.996c0-.642.521-1.163 1.164-1.163zm4.164 9.54l-5.735 5.732-.43 2.151 2.152-.43 5.731-5.728c.459-.482.463-1.243-.004-1.726-.474-.472-1.241-.471-1.714.002zm-10.053-.78c.128-.18.378-.221.558-.093.18.128.222.378.094.558l-1.648 2.305c-.034.046-.055.07-.081.095-.305.305-.8.305-1.106 0l-.826-.825c-.156-.156-.156-.41 0-.566.156-.156.41-.156.566 0l.81.81zm5.665 1.15c.222 0 .4.216.4.481 0 .266-.178.482-.4.482h-3.05c-.222 0-.401-.216-.401-.482 0-.265.179-.481.4-.481zM7.248 6.782c.128-.18.378-.222.558-.093.18.128.222.378.094.558L6.252 9.552c-.033.044-.033.044-.082.096-.305.304-.8.303-1.105-.001l-.826-.825c-.156-.156-.156-.41 0-.566.156-.156.41-.157.566 0l.81.809zm5.665 1.15c.222 0 .4.215.4.481s-.178.481-.4.481h-3.05c-.222 0-.401-.215-.401-.48 0-.267.179-.482.4-.482z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-112 -25) translate(112 23) translate(0 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ez22kxmnrb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wivl7i7uxa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#wivl7i7uxa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0057A0",
    mask: "url(#ez22kxmnrb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V22H0z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskRequests);
export default __webpack_public_path__ + "static/media/task-requests.2723a2eeb6218731f5bbd25ca0968b74.svg";
export { ForwardRef as ReactComponent };